import { render, staticRenderFns } from "./LocationTable.vue?vue&type=template&id=6e2f8865"
import script from "./LocationTable.vue?vue&type=script&lang=js"
export * from "./LocationTable.vue?vue&type=script&lang=js"
import style0 from "./LocationTable.vue?vue&type=style&index=0&id=6e2f8865&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports